// extracted by mini-css-extract-plugin
export default {"text":"Home_text__YlQ2v","cardWrapper":"Home_cardWrapper__r8fIC","signinWrapper":"Home_signinWrapper__HGSsp","hasInvite":"Home_hasInvite__fmmuk"};